import React, { Component } from 'react';
import { connect } from 'react-redux'
import { closePopup } from '../../actions/popup';

@connect(state => ({
    isErrorToastPopupOpened: state.popup.isErrorToastPopupOpened,
    title: state.popup.title,
    description: state.popup.description,
}), dispatch => ({
    handlePopupClose: () => {
        dispatch(closePopup())
    },
}))
class ErrorToastPopup extends Component {
    constructor() {
        super();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isErrorToastPopupOpened)
            setTimeout(() => { this.props.handlePopupClose() }, 2000)
    }

    render() {
        return (
            <div className="blog_layer" style={{position: 'fixed', top: '50%', marginTop: '-59px', display: this.props.isErrorToastPopupOpened?'block':'none'}}>
                <div className="inner_blog_layer inner_blog_layer2">
                    <strong className="tit_popup">{this.props.title}</strong>
                    <span className="txt_popup">{this.props.description}</span>
                </div>
            </div>
        );
    }
}

export default ErrorToastPopup;
